import { PromoAnalyticsService } from '@analytics/feature';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VOUCHER_QUERY_NAME } from '@cart/const';
import { ActiveCartService, CartActions, CartVoucherService } from '@cart/data-access';
import { EnvironmentService } from '@core/feature';
import { Actions, EffectNotification, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';
import { ActivatedRouterStateSnapshot } from '@spartacus/core';
import { EMPTY, Observable, iif } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class CartVoucherBrowserEffects {
  addVoucherFromQuery$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        map(
          (action: RouterNavigatedAction<ActivatedRouterStateSnapshot>) =>
            action.payload.routerState.queryParams[VOUCHER_QUERY_NAME],
        ),
        filter((voucherFromQuery: string) => !!voucherFromQuery),
        map((voucherFromQuery: string) => {
          this.activeCartService
            .requireLoadedCart()
            .pipe(
              switchMap(() => this.activeCartService.getActiveCartId()),
              filter((cartId: string) => !!cartId),
              take(1),
            )
            .subscribe((cartId: string) => {
              this.cartVoucherService.addVoucher(voucherFromQuery, cartId);
              this.router.navigate([], {
                queryParams: {
                  [VOUCHER_QUERY_NAME]: null,
                },
                queryParamsHandling: 'merge',
                relativeTo: this.activatedRoute,
              });
            });

          return;
        }),
      ),
    { dispatch: false },
  );

  addCartVoucherSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CartActions.CART_ADD_VOUCHER_SUCCESS),
        map((action: CartActions.CartAddVoucherSuccess) => {
          const { voucherId } = action.payload;
          const status = `Промокод ${voucherId} применён успешно`;

          this.promoAnalyticsService.onApplyPromocode(voucherId, status);
        }),
      ),
    { dispatch: false },
  );

  addCartVoucherFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CartActions.CART_ADD_VOUCHER_FAIL),
        map((action: CartActions.CartAddVoucherFail) => {
          const { error, voucherId } = action.payload;
          const text: string = ((): string => {
            if (error.status === 404) {
              return 'По данному коду ничего не найдено';
            }
            switch (error.details[0].message) {
              case 'coupon.not.found.for.site':
                return 'По данному коду ничего не найденоForSite';

              case 'coupon.not.active.expired':
                return 'Промокод не активен';

              case 'coupon.already.redeemed':
                return 'Промокод уже использован';

              default:
                return 'Ошибка применения промокода';
            }
          })();

          this.promoAnalyticsService.onApplyPromocode(voucherId, text);
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private activeCartService: ActiveCartService,
    private cartVoucherService: CartVoucherService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private promoAnalyticsService: PromoAnalyticsService,
    private environmentService: EnvironmentService,
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return iif(() => this.environmentService.isPlatformBrowser, resolvedEffects$, EMPTY);
  }
}
